const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject('No file provided');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64String = reader.result.split(',')[1];
      resolve({
        fileName: file.name,
        contentType: file.type,
        fileContent: base64String,
      });
    };

    reader.onerror = (error) => reject('Error reading file: ' + error);
  });
};

export default fileToBase64;
